// India's Inking Service — Brand Constants
export const BRAND = {
  name: "India's Inking Service",
  shortName: "India's Inking",
  ownerFirstName: "India",
  ownerLastName: "Scruggs",
  ownerFullName: "India Scruggs",
  tagline: "Professional. Secure. MBA-Led.",
  phone: "(615) 347-3512",
  phoneRaw: "+16153473512",
  email: "india@indiasinkingservice.com",
  city: "Nashville",
  state: "TN",
  serviceArea: "Nashville · Brentwood · Franklin · Hendersonville · Murfreesboro",
  facebookUrl: "https://www.facebook.com/p/Indias-Inking-Service-100057423130278/",
  googleReviewsUrl: "https://share.google/gn8rRayjsOGEbnmam",
  // Replace with the GHL calendar URL when ready (e.g. https://link.msgsndr.com/widget/booking/XXX).
  // Until set, the CTA button falls back to the internal /booking page.
  ghlBookingUrl: "",
  logoUrl: "https://lh3.googleusercontent.com/p/AF1QipML-dqhFayrt-yKWjOBMyFGfVYl1SeC7xSmy_J8=s680-w680-h510-rw",
  footerLogoUrl: "https://lh3.googleusercontent.com/p/AF1QipML-dqhFayrt-yKWjOBMyFGfVYl1SeC7xSmy_J8=s680-w680-h510-rw",
  headshotUrl: "https://lh3.googleusercontent.com/p/AF1QipM_NlN_gfhel7tbgYY4CzOEZmzRCxxHvnd8yvsD=s680-w680-h510-rw",
  heroBgUrl: "https://customer-assets.emergentagent.com/job_b8675834-c8ae-4883-bbc8-723ef71e34e7/artifacts/mj9l5ij8_iStock-1151607202-scaled.jpg",
};

// Three-tier coverage messaging — used in footer, services page, and every service detail page.
// India is intentionally not "just local": she runs a national signing network and offers worldwide RON.
export const COVERAGE = {
  headline: "Nashville · Nationwide · Worldwide",
  tiers: [
    {
      label: "Mobile Notary · In-Person",
      area: "Nashville & Middle Tennessee",
      detail: "Davidson, Williamson, Sumner, Rutherford & surrounding counties",
    },
    {
      label: "Signing-Agent Network",
      area: "Nationwide",
      detail: "Vetted notary partners across the United States",
    },
    {
      label: "Remote Online Notarization",
      area: "Anywhere in the world",
      detail: "Tennessee-compliant RON for clients abroad, deployed, or traveling",
    },
  ],
};

// Nashville-themed hero background — Variant A (the chosen home variant)
export const NASHVILLE_HEROES = {
  v1: {
    image: "https://customer-assets.emergentagent.com/job_b8675834-c8ae-4883-bbc8-723ef71e34e7/artifacts/mj9l5ij8_iStock-1151607202-scaled.jpg",
    label: "Nashville Skyline",
    caption: "Downtown Nashville · Cumberland River",
  },
};

// Demo testimonial avatars (Unsplash portrait stock)
export const REVIEWER_AVATARS = {
  "Kenyata Hillsman": "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&h=200&fit=crop&crop=faces",
  "Nat Tauer": "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces",
  "Felicia Bryson": "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=faces",
};

// Wedding officiant page imagery (Unsplash)
export const WEDDING_IMAGES = {
  hero: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1920&q=80",
  ceremony: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=900&q=80",
  rings: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=900&q=80",
  outdoor: "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=900&q=80",
  couple: "https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=900&q=80",
  bouquet: "https://images.unsplash.com/photo-1546195643-70f48f9c5b87?w=900&q=80",
};

export const COLORS = {
  maroon: "#800000",
  maroonHover: "#5C0000",
  maroonDeep: "#4A0000",
  gold: "#D4AF37",
  goldHover: "#B8941F",
  goldSoft: "#F5E6A8",
  cream: "#FBF8F1",
  white: "#FFFFFF",
  ink: "#1A1A1A",
  textMuted: "#5C5C5C",
  border: "#E8E2D5",
};
